import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
   },
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta:'home'
    },
    {
      path: '/cochain',
      name: 'cochain',
      component: () => import( './views/CoChain.vue'),
      meta:'cochain'
    },
    {
      path: '/wallet',
      name: 'wallet',
      component: () => import( './views/Wallet.vue'),
      meta:'wallet'
    },
    {
      path: '/developerapplication',
      name: 'developerapplication',
      component: () => import( './views/DeveloperApplication.vue'),
      meta:'developer'
    },
    {
      path: '/developer',
      name: 'developer',
      component: () => import( './views/Developer.vue'),
      meta:'developer'
    },
    {
      path: '/service',
      name: 'service',
      component: () => import( './views/Service.vue'),
      meta:'service'
    },
    {
      path: '/message',
      name: 'message',
      component: () => import( './views/Message.vue'),
      meta:'message'
    },
    {
      path: '/announcementDetial',
      name: 'announcementDetial',
      component: () => import( './views/announcementDetial.vue'),
      meta:'announcementDetial'
    },
    {
      path: '/weeklyDetail',
      name: 'weeklyDetail',
      component: () => import( './views/weeklyDetail.vue'),
      meta:'weeklyDetail'
    },
    {
      path: '/reportDetail',
      name: 'reportDetail',
      component: () => import( './views/reportDetail.vue'),
      meta:'reportDetail'
    },
    {
      path: '/team',
      name: 'team',
      component: () => import( './views/Team.vue'),
      meta:'team'
    },
    {
      path: '/download',
      name: 'download',
      component: () => import( './views/Download.vue'),
      meta:'download'
    },
    {
      path: '/chromeExtension',
      name: 'chromeExtension',
      component: () => import( './views/chromeExtension.vue'),
      meta:'chromeExtension'
    },
  ]
})
